import React, { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import midiakitPdf from './src/midiakit.pdf';
import styles from './midiakit_carolrochaak.module.scss';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Midiakit_carolrochaak: React.FC = () => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [pdfWidth, setPdfWidth] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                setPdfWidth(containerRef.current.offsetWidth * 0.92);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={styles.page}>
            <header className={styles.header}>
                <Link to="/carolrochaak" className={styles.backButton} aria-label="Voltar">
                    <FaArrowLeft />
                </Link>
                <h1>Mídia Kit</h1>
            </header>

            <div ref={containerRef} className={styles.pdfWrap}>
                <Document
                    file={midiakitPdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<p className={styles.loading}>Carregando PDF...</p>}
                >
                    {numPages
                        ? Array.from({ length: numPages }, (_, index) => (
                              <Page
                                  key={`page_${index + 1}`}
                                  pageNumber={index + 1}
                                  width={pdfWidth}
                                  renderTextLayer
                                  renderAnnotationLayer
                              />
                          ))
                        : null}
                </Document>
            </div>
        </div>
    );
};

export default Midiakit_carolrochaak;
